import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { StorageService } from "./services/StorageService";
import { Constants } from "./Constants";

const storageService = new StorageService();
const selectedLanguage = storageService.get(Constants.storage.keys.selectedLanguage) || "en";

i18next
    .use(initReactI18next)
    .use(Backend)
    .init({
        returnObjects: true,
        fallbackLng: "en", // Language to fallback to if the selected is not configured
        debug: false, //To enable us see errors
        lng: selectedLanguage, //Default language as english
    });